import { render, staticRenderFns } from "./PatientSelectModal.vue?vue&type=template&id=1a8e50c0"
import script from "./PatientSelectModal.vue?vue&type=script&lang=js"
export * from "./PatientSelectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports